<template>
  <div class="combinationBox">
    <div class="projectSelect">
      <el-form ref="valueForm" :model="form" class="valueForm">
        <el-form-item prop="valueSelect" :rules="[{ type: 'array', required: true, message: '请至少选择一个项目编号', trigger: 'change' }]">
          <project-select v-model="form.valueSelect" :fields="fields" :type="type" :size="size" @change="valueChange" @setOptions="setOptions" />
        </el-form-item>
      </el-form>

    </div>
    <div class="shareScalesBox">
      <div class="shareScalesTips">
        <span v-if="type === 'edit'" :style="{ color: formItemError ? '#F53F3F' : '#4E5969' }">（
          当前总和应为100，当前为
          <span v-if="type === 'edit'" :style="{ color: formItemError ? '#F53F3F' : '#165dff' }">{{ percentTotal }}</span>）
        </span>
        <el-button v-if="type === 'edit'" type="primary" size="mini" class="equalDistribution" @click="averageDistribute">平均分配</el-button>
      </div>
      <div class="condition-box">
        <!-- <div class="average">
                    <span @click="averageDistribute" v-if="type === 'edit'">平均分配</span>
                </div> -->
        <div class="title-box">
          <div>项目编号</div>
          <div>项目明细</div>
          <div>分配百分比%</div>
        </div>

        <el-form v-show="numForm.valueObj.length" ref="valueObjForm" :model="numForm" class="valueObjForm">
          <div v-for="(item, index) in numForm.valueObj" :key="index" class="item-box" :class="{ 'item-box-bottom': index }">
            <el-form-item>
              <el-select
                v-model="item.projectId"
                style="width: 100%"
                placeholder="请选择"
                size="medium"
                disabled
                clearable
              >
                <el-option
                  v-for="itemOption in options"
                  :key="itemOption.id"
                  :label="itemOption.label"
                  :value="itemOption.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <div class="projectDetails">
                <option-view :item="findItem(item)" />
              </div>
            </el-form-item>
            <el-form-item :prop="'valueObj.' + index + '.shareScale'" :rules="itemRules">
              <el-input-number
                v-model="item.shareScale"
                size="medium"
                controls-position="right"
                :min="0"
                :max="100"
                :precision="0"
                style="width:100%"
                placeholder="请输入"
                :controls="false"
                :disabled="type === 'readOnly'"
                @change="val => numberChanged(val, index)"
              />
            </el-form-item>
          </div>
        </el-form>

        <div v-if="numForm.valueObj.length == 0" class="no-job" style="text-align: center">暂无数据</div>

      </div>
    </div>

  </div>
</template>

<script>
import projectSelect from './index.vue'
import optionView from './optionView'
import axios from 'axios'
import { mapState } from 'vuex'
import { debounce } from 'throttle-debounce'
export default {
  name: 'Combination',
  components: {
    projectSelect,
    optionView
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    fields: {
      type: Object,
      default: () => {}
    },
    // type: {
    //     type: String,
    //     default: 'edit'
    // },
    size: {
      type: String,
      default: 'medium'
    },
    isPrint: {
      type: Boolean,
      default: false // 是否parse解析器解析
    },
    isText: {
      type: Boolean,
      default: false // 是否禁止编辑
    }
  },
  data() {
    const numberValidator = (rule, value, callback) => {
      // 校验数字验证器，此列数字总和不为100时，提示错误提示
      const total = this.numForm.valueObj.reduce((pre, cur) => {
        const totalNumber = pre + Number(cur.shareScale)
        return totalNumber
      }, 0)
      console.log(total)

      if (total < 100 || total > 100) {
        this.formItemError = true
        callback(new Error('此列总和应等于100'))
      } else {
        this.formItemError = false
        const clearArray = []
        for (let i = 0; i < this.numForm.valueObj.length; i++) {
          clearArray.push(`valueObj.${i}.shareScale`)
        }
        this.$refs.valueObjForm.clearValidate(clearArray)
        callback()
      }
    }
    return {
      form: {
        valueSelect: []
      },
      numForm: {
        valueObj: []
      },

      valueObj: [],
      options: [],
      formItemError: false,
      itemRules: [
        {
          validator: numberValidator,
          trigger: 'blur'
        }
      ],
      optionsRender: true,
      projectDetails: []

    }
  },
  computed: {
    ...mapState('user', ['userInfo']),
    percentTotal() {
      const total = this.numForm.valueObj.reduce((pre, cur) => {
        const totalNumber = pre + Number(cur.shareScale)
        return totalNumber
      }, 0)
      return total
    },
    type() {
      if (this.isPrint || this.isText) {
        return 'readOnly'
      } else {
        return 'edit'
      }
    }
  },
  watch: {
    value: {
      handler(val) {
        this.dataInit()
        this.projectDetailsInit()
      },
      deep: true
    }
  },
  created() {
    this.dataInit()
    this.projectDetailsInit()
  },
  mounted() {
    this.validateInit()
  },
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {},
  methods: {
    setOptions(list) {
      this.options = list
    },
    dataInit() {
      if (this.value && this.value instanceof Array) {
        const valueSelect = []
        this.numForm.valueObj = this.value
        for (let i = 0; i < this.value.length; i++) {
          valueSelect.push(this.value[i].projectId)
        }
        this.form.valueSelect = valueSelect
      }
    },
    numberChanged(val, index) {
      // 百分比必须输入且最小为0
      if (typeof val !== 'number') {
        val = 0
        this.$set(this.numForm.valueObj[index], 'shareScale', 0)
      }
      this.$emit('input', this.numForm.valueObj)
    },
    averageDistribute() {
      // 平均分配计算方法，若能平分为整数直接赋值，否则前面的取整数位，最后一项为100 - 前面的和
      const averageNumber = 100 / this.numForm.valueObj.length
      if (Number.isInteger(averageNumber)) {
        this.numForm.valueObj.map(item => {
          item.shareScale = averageNumber
          return item
        })
      } else {
        this.numForm.valueObj.map((item, index) => {
          if (index !== this.numForm.valueObj.length - 1) {
            item.shareScale = Math.trunc(averageNumber)
          } else {
            item.shareScale = 100 - (this.numForm.valueObj.length - 1) * Math.trunc(averageNumber)
          }
          return item
        })
      }
      this.$refs.valueObjForm.validate()
      this.$emit('input', this.numForm.valueObj)
    },
    valueChange() {
      this.valueObjInit()
      this.$emit('input', this.numForm.valueObj)
    },
    valueObjInit() {
      const arr = []
      for (let i = 0; i < this.form.valueSelect.length; i++) {
        arr.push({
          projectId: this.form.valueSelect[i],
          shareScale: 0,
          type: 'YC-PROJECT-NUMBER-FIELD'
        })
      }
      this.numForm.valueObj = arr
      if (arr.length === 1) {
        this.$nextTick(() => {
          this.averageDistribute()
        })
      }
    },
    validateInit() {
      const projectIdValidates = this.$store.state.app.projectIdValidates
      if (this.fields?.bpmConfig?.required) {
        projectIdValidates.push(this.$refs.valueForm.validate)
      }
      projectIdValidates.push(this.$refs.valueObjForm.validate)
    },
    findItem(val) {
      const r = this.projectDetails.find(item => item.projectId === val.projectId)
      return r || {}
    },
    projectDetailsInit: debounce(500, function() {
      this.projectDetailsInitFN()
    }),
    projectDetailsInitFN() {
      const projectIds = this.form.valueSelect
      if (projectIds.length === 0) {
        return
      }
      const data = {
        projectTypes: [],
        search: '',
        // userId: this.userInfo.externalUserId,//这个是展示项目编号详情，所以不应该传userId，不然会看不见
        projectIds,
        isShowAll: this.type === 'readOnly'
      }

      if (process.env.NODE_ENV === 'test') {
        data.userId = 1
      }
      axios({
        method: 'POST',
        url: process.env.VUE_APP_YC + '/feign/projectId/getProjectId',
        data
      }).then(e => {
        const res = e.data
        if (res && res.code === '200' && res.data && res.data instanceof Array) {
          this.projectDetails = res.data
          this.optionsRender = false
          this.$nextTick(() => {
            this.optionsRender = true
          })
        }
      })
    }

  }
}
</script>
<style lang="scss" scoped>
.combinationBox{
  .el-form{
    padding-top: 0 !important;
    .el-form-item{
        margin-bottom: 10px !important;
    }
  }
  .valueForm{
    .el-form-item{
            padding-right: 0px;
    }
  }

}
.condition-box {
  width: 100%;
  padding:10px;
  background: #f7f8fa;
  border-radius: 4px;
  .average {
    width: 100%;
    text-align: right;
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #165dff;
    line-height: 22px;
    span {
      cursor: pointer;
    }
  }
  .title-box {
    display: flex;
    width: 100%;
    div {
      padding-left: 10px;
      font-size: 12px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 22px;
    }
    div:first-child {
      width: 40%;
    }
    div:nth-child(2) {
      width: 45%;
    }
    div:last-child {
      width:15%;
    }
  }
  .item-box {
    display: flex;
    //height: 32px;
    align-items: center;
    border: 1px #e3e3e3 solid;
    border-top: none;
    ::v-deep .el-form-item__error {
      display: none;
    }
    ::v-deep .el-form-item {
      margin-bottom: 0 !important;
    }
    ::v-deep(.el-form-item__content) {
      margin-left: 0 !important;
    }
    .el-form-item:nth-of-type(1){
        width:40%;
        padding-left: 10px;
    }
    .el-form-item:nth-of-type(2){
        width:45%;
        border-left: 1px #e3e3e3 solid;
        border-right: 1px #e3e3e3 solid;
        padding-left: 10px;
    }
    .el-form-item:nth-of-type(3){
        width:15%;
        padding-left: 10px;
    }
  }
  .item-box:nth-of-type(1){
    border-top: 1px #e3e3e3 solid;
  }
  .no-job {
    text-align: center;
    height: 48px;
    line-height: 48px;
    font-size: 12px;
    color: #4e5969;
  }

}
.shareScalesTips{
    margin-bottom: 10px;
    text-align: right;
}
</style>
